import { z } from 'zod';

export const GetProposalServiceRequestSchema = z
  .object({
    campaignProposalId: z.number(),
  })
  .describe('GetProposalServiceRequestSchema');

export type GetProposalServiceRequest = z.infer<typeof GetProposalServiceRequestSchema>;

const CouponNameInfoSchema = z.object({
  type: z.enum(['FOLLOWER', 'NICKNAME', 'BRAND']),
  templateLabel: z.string(),
  personalizedLabel: z.string(),
});

export type CouponNameInfo = z.infer<typeof CouponNameInfoSchema>;

export const GetProposalServiceResponseSchema = z.object({
  campaignProposalId: z.number(),
  brandImageUrl: z.string(),
  brandId: z.string(),
  brandName: z.string(),
  progressStatus: z.string(),
  proposalDate: z.string(),
  goodsCount: z.number(),
  salesRate: z.number(),
  couponQuantityLimit: z.number(),
  period: z.string(),
  couponNameInfos: z.array(CouponNameInfoSchema),
  isProposalActionVisible: z.boolean(),
});

export type GetProposalServiceResponse = z.infer<typeof GetProposalServiceResponseSchema>;
